module.exports = __webpack_public_path__ + "img/2025-08-16c_1.0f088f37.jpg";